export default "__VITE_ASSET__BXHgPtHR__"